import createTypes from 'redux-create-action-types';

export default createTypes('TOGGLE_COLLAPSED_NAV', 'NAV_STYLE', 'WINDOW_WIDTH');
